<template>
    <b-col class="animated fadeIn">
        <b-row class="justify-content-center">
            <b-col>
                <b-row class="mt-4">
                <div class="col-sm-6 col-lg-3" v-for="app in apps" :key="app.name">
                  <b-link>
                  <b-card :no-body="true" @click="navigate(app)">
                    <div class="p-3 clearfix">
                      <i class="fa fa-laptop bg-info p-3 font-2xl mr-3 float-left"></i>
                      <div class="h5 text-info mb-0 mt-2">{{app.name}}</div>
                            <small class="text-muted">{{app.info}}</small>
                    </div>
                  </b-card>
                  </b-link>
                </div>
                </b-row>
            </b-col>
        </b-row>

                <b-card no-body>
                    <div slot="header"> Todo List
                      <div class="card-header-actions">
                        <b-row>       
                        <span class="pt-1 pr-2">Filter</span>
                        <input type="search" style="width:200px; height:34px !important; margin-right:2px;" v-model="filter"  placeholder="Type to Search"/>
                        <b-pagination v-show="(todos.items.length>0)"
                          align="right" style="margin-bottom: -25px !important;"
                          :total-rows="todos.total"
                          :per-page="todos.limit"
                          v-model="todos.page"
                        ></b-pagination>
                        </b-row>
                      </div>

                      <!-- <div style="float:right; margin-right:10px;"> 
                        <b-input-group size="sm" class="ml-1">
                              <b-input-group-prepend> <span class="pr-2">Filter </span></b-input-group-prepend>
                            <b-form-input v-model="filter" type="search" placeholder="Type to Search"></b-form-input>
                            <b-input-group-append>
                                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                            </b-input-group-append>
                        </b-input-group>
                      </div> -->

                    </div>

                  <!-- <div v-show="(todos.items.length>0)" style="margin-top:-21px;"> -->
                    <b-table
                        class="ml-1"
                        ref="tblTaskTodo"
                        responsive striped hover small
                         style="font-size:smaller;" 
                        :items="todos.items"
                        :fields="todoFields"
                        :current-page="todos.page"
                        :per-page="todos.limit"
                        :sort-by.sync="todos.sortBy"
                        :sort-desc.sync="todos.sortDesc"
                        @row-clicked="selectItem" 
                        :filter="filter"
                        @filtered="onFiltered"
                        show-empty
                      >
                      <template v-slot:cell(createdate)="data">
                        {{ data.item.createdate | moment("DD MMM YYYY") }}
                      </template>
                      <template v-slot:cell(empty)="scope">
                        <h4>{{ scope.emptyText }}</h4>
                      </template>

                    </b-table>
                  <!-- </div> -->
                </b-card>
                <b-card header="Activity / Agenda">

                </b-card>

    </b-col>
</template>

<style lang="scss" scoped>
.card {
  &.link {
    cursor: pointer;
    transition: all 0.4s;

    &:hover {
      background-color: #f0f3f5;
    }
  }

  .card-body {
    height: 140px;
  }
}
</style>


<script>
import toastr from "mini-toastr";
import modules from "../apis/modules";
toastr.init();

export default {
  data() {
    return {
      apps: [],
      todos:{
        items:[],
        page: 1,
        limit: 10,
        total: 0,
        sortBy: 'createdate',
        sortDesc: true,
      },
      todoFields: [
          {
            key: "taskname",
            label: "Doc./Task Name",
            sortable: true
          },
          {
            key: "taskdetail",
            label: "Doc./Task Description",
          },
          {
            key: "createby",
            label: "Created By",
            sortable: true
          },
          {
            key: "createdate",
            thStyle: "width:110px",
            label: "Created @",
          },
      ],
      filter:''
    };
  },
  computed: {
    compcode(){
      return this.$store.state.user.compcode;
    },
  },
  watch:{
    filter: function(newVal, oldVal) {
      if (oldVal !== undefined && newVal !== oldVal) {
        this.todos.page = 1;
      }
      this.saveFilter();
    },
    "todos.page": function() {
      this.saveFilter();
    },
    "todos.sortBy": function() {
      this.saveFilter();
    },
    "todos.sortDesc": function() {
      this.saveFilter();
    },
    compcode: function(newval){
      toastr.warn('Company has been changed');
      this.TaskTodo();
    },
  },  
  created: async function() {
    this.restoreFilter();
    this.apps = await modules.apps();
    setTimeout(() => {
      this.TaskTodo();
    }, 100);
  },
  beforeRouteLeave(to, from, next) {
    this.saveFilter();
    next();
  },
  sockets: {
        task_changed: function (data) {
            console.log('socket server emit task_changed',data);
            if (data.compcode === this.$store.state.user.compcode) {
              this.TaskTodo();
            }        
        },
  },  

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.todos.total = filteredItems.length;
      const maxPage = Math.ceil(this.todos.total / this.todos.limit) || 1;
      if (this.todos.page > maxPage) {
        this.todos.page = 1;
      }
    },    
    TaskTodo: function() {
       return modules.listtodo(this.todos).then((list) => {
          this.todos.items = list || [];
          this.todos.total = (list || []).length;
          const maxPage = Math.ceil(this.todos.total / this.todos.limit) || 1;
          if (this.todos.page > maxPage) {
            this.todos.page = 1;
          }
          return list;
        });
    },
    saveFilter() {
      const modulesFilter = {
        filter: this.filter,
        page: this.todos.page,
        limit: this.todos.limit,
        sortBy: this.todos.sortBy,
        sortDesc: this.todos.sortDesc,
      };
      const filter = this.$store.state.filter || {};
      filter.modules = modulesFilter;
      this.$store.commit("filter", filter);
    },
    restoreFilter() {
      const filter = this.$store.state.filter;
      if (filter && filter.modules) {
        if (filter.modules.filter !== undefined) {
          this.filter = filter.modules.filter;
        }
        if (filter.modules.page) {
          this.todos.page = filter.modules.page;
        }
        if (filter.modules.limit) {
          this.todos.limit = filter.modules.limit;
        }
        if (filter.modules.sortBy) {
          this.todos.sortBy = filter.modules.sortBy;
        }
        if (filter.modules.sortDesc !== undefined) {
          this.todos.sortDesc = filter.modules.sortDesc;
        }
      }
    },
    async refresh(ctx) {
      this.$refs.tblTaskTodo.refresh();
    },
    selectItem(item,index) {
      this.saveFilter();
      if (item.routeParam){
          this.$router.push({name :item.routeName, params: JSON.parse(item.routeParam)});
      } else {
          this.$router.push({name :item.routeName});
      }
    },    
    navigate(app) {
      this.saveFilter();
      const { $router } = this;
      const { url } = app;

      if (url) {
        if (app.statichtml=='1') {
              location.href=url;
        } else {
          if (url.indexOf("http") === 0) {
            window.open(url, "_blank");
          } else {
            $router.push(url);
          }
        }
      }
    }
  }
};
</script>
